import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { Observable } from 'rxjs';
export interface CheckPersonResponse {
  status: string
  data: boolean
}

@Injectable({
  providedIn: 'root'
})
export class ComplaintFormService {

  constructor(private readonly httpservice: HttpService) {}

  sendOTPEmail( email: string): Observable<any> {
    const request = {email};
    return this.httpservice.post('/complaint/send-otp', request);
  }

  verifyEmail( email: string, otp: string): Observable<any> {
    const request = { email, otp };
    return this.httpservice.post('/complaint/verify-otp', request);
  }

  verifySubmit(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/submit-complaint-form', payload);
  }

  internalSubmit(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/submit-internal-complaint-form', payload);
  }

  searchLicensedEducator(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/searchLicensedEducator', payload);
  }

  fetchComplaintDetails(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/getComplaintDetails', payload);
  }
  getPersonByRole(): Observable<any> {
    return this.httpservice.get('/complaint/persons-by-role');
  }

  uploadFile(file: File, type: string, fileName: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    formData.append('fileName', fileName);
    return this.httpservice.post('/registration/upload', formData);
  }
  getUploadKey(data) {
    return this.httpservice.post('/complaint/upload-key', data);
  }

  updateComplaintStatus(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/update-complaint-status', payload);
  }
  updateComplaintArchivalStatus(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/update-archival-status', payload);
  }
  insertComplaintNotes(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/insert-complaint-notes', payload);
  }
  deleteComplaintNotes(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/delete-complaint-notes', payload);
  }
  updateComplaintNotes(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/update-complaint-notes', payload);
  }
  insertComplaint(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/insert-complaint', payload);
  }
  getComplaintActivationId(): Observable<any> {
    return this.httpservice.get('/complaint/complaint-activationId');
  }
  insertTimeLineEntryComplaint(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/insert-complaint-timeline', payload);
  }
  getComplaintTimeLine(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/get-complaint-timeline', payload);
  }
  linkComplaintEducator(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/insert-complaint-educator', payload);
  }
  deleteComplaintEducator(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/delete-complaint-educator', payload);
  }
  insertSupportingDocument(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/insert-supporting-document', payload);
  }
  deleteSupportingDocument(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/delete-supporting-document', payload);
  }
  insertWitnessDocument(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/insert-witness-document', payload);
  }
  updateWitnessDocument(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/edit-witness-document', payload);
  }
  deleteWitnessDocument(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/delete-witness-document', payload);
  }
  updateComplaint(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/update-complaint', payload);
  }
  updateComplaintAssignee(payload: any): Observable<any> {
    return this.httpservice.post('/complaint/update-complaint-assignee', payload);
  }

  getPersonIdByLicenseNumberAndEmail(email: string, licenseNumber: string): Observable<any> {
    return this.httpservice.post('/complaint/get-person-id-by-email-or-license', { email, licenseNumber });
  }
}